import { defineAsyncComponent as e } from "vue";
import { getI18n as t } from "@editor/ui-utils";
//#endregion
//#region src/lang/index.ts
var n = {
	en: {
		recipeApi: {
			created: "Recipe created",
			updated: "Recipe updated",
			notFound: "Recipe not found",
			requiredFields: "The recipe cannot be saved because mandatory information is missing."
		},
		recipeList: {
			newButton: "New recipe",
			name: "Search for recipe title or ID",
			deleteRecipe: "Delete",
			duplicate: "Duplicate",
			dpAny: "All",
			brand: "Brand",
			loading: "Loading recipe",
			headerLabel: "Recipe name",
			headerTextContent: "Recipe content",
			headerCreatedAt: "Creation date",
			headerChangedAt: "Last modified date",
			counter: "Counter",
			dpEdit: "Edit",
			dpView: "View",
			messageDeleted: "Message deleted",
			errorOnDeleting: "Error deleting",
			createRecipe: "Create recipe"
		},
		recipe: {
			recipeLabel: "Recipe",
			newRecipe: "New Recipe",
			messageDeleteRecipe: "Delete Recipe",
			messageDeleteRecipeTitle: "Are you sure you want to delete this Recipe? It will be deleted wherever it is currently used.",
			deleteRecipe: "Delete",
			placeholder: "Select Recipe",
			messageDeleted: "Recipe deleted",
			errorOnDeleting: "Error deleting the recipe",
			errorFailedLoadedRecipeWithId: "Error getting the recipe",
			handledInLegacySystem: "This Recipe is being handled in {source}, you can't edit it on Vibe"
		},
		recipeEdit: {
			label: "Name of the recipe",
			counter: "Counter",
			editRecipe: "Edit recipe",
			messageSaved: "Recipe saved",
			messageUpdated: "Changes saved",
			season: "Season",
			categories: "Categories",
			fitFactors: "Fit-factors",
			difficulty: "Difficulty",
			effort: "Effort",
			basics: "Basics",
			ingredients: "Ingredients",
			preparation: "Preparation",
			addIngredient: "Add ingredient",
			ingredientsName: "Name of the ingredient",
			ingredientsAmount: "Amount",
			ingredientsUnit: "Unit",
			addPreparationStep: "Add preparation step",
			preparationStepDescription: "Description",
			preparationStepIngredients: "Ingredients",
			cookingTime: "Cooking time (minutes)",
			totalTime: "Total time (minutes)",
			minutes: "Minutes",
			noTime: "No time specified",
			portions: "Portions",
			portionUnit: "Portion unit",
			closingText: "Closing text",
			nutritionalValues: {
				title: "Nutritional values",
				calories: "Calories (kcal)",
				protein: "Protein (g)",
				carbs: "Carbs (g)",
				fat: "Fat (g)"
			}
		},
		season: {
			winter: "Winter",
			spring: "Spring",
			easter: "Easter",
			summer: "Summer",
			fall: "Fall",
			christmas: "Christmas"
		},
		difficulty: {
			easy: "Easy",
			medium: "Medium",
			hard: "Hard"
		},
		effort: {
			quick: "Quick",
			medium: "Medium",
			long: "Laborious"
		},
		category: {
			fruehstueck: "Breakfast/Snack",
			fleisch: "Meat",
			fisch: "Fish",
			pasta: "Pasta",
			vegetarisch: "Vegetarian",
			suppe: "Soup",
			drink: "Drink",
			salat: "Salad",
			vorspeise: "Appetizer",
			dessert: "Dessert",
			vegan: "Vegan",
			smoothie: "Smoothie",
			superfood: "Superfood",
			snack: "Snack",
			hauptgericht: "Main Course",
			rohkost: "Raw food",
			mealprep: "Meal Prep",
			"schnelle-rezepte": "Quick recipes",
			kekse: "Cookies",
			brot: "Bread",
			kuchen: "Cake",
			gefluegel: "Poultry",
			rindfleisch: "Beef",
			schweinefleisch: "Pork",
			wild: "Game",
			preiswert: "Affordable",
			ofengerichte: "Oven dishes",
			asiatisch: "Asian",
			mediterran: "Mediterranean",
			orientalisch: "Oriental",
			"dips-aufstriche": "Dips & Spreads"
		},
		fitFactor: {
			"low-fat": "Low fat",
			"low-carb": "Low carb",
			"weniger-als-300-kcal": "Less than 300 kcal",
			eiweissbetont: "Protein-rich",
			"gegen-heisshunger": "Against cravings",
			muskelaufbau: "Muscle building",
			regeneration: "Regeneration (carbohydrates & protein)",
			paleo: "Paleo",
			glutenfrei: "Gluten-free",
			laktosefrei: "Lactose-free",
			zuckerfrei: "Sugar-free",
			vitaminreich: "Vitamin-rich",
			ballaststoffreich: "Fiber-rich",
			basisch: "Alkaline",
			"unter-500-kcal": "Under 500 kcal",
			"clean-eating": "Clean eating",
			detox: "Detox"
		},
		portionUnit: {
			person: "Person(s)",
			piece: "Piece"
		}
	},
	de: {
		recipeApi: {
			created: "Rezept erstellt",
			updated: "Rezept aktualisiert",
			notFound: "Rezept nicht gefunden",
			requiredFields: "Das Rezept kann nicht gespeichert werden, weil Pflichtinformationen fehlen."
		},
		recipeList: {
			newButton: "Neues Rezept",
			name: "Suchen nach Titel oder ID des Rezepts",
			deleteRecipe: "Löschen",
			duplicate: "Duplizieren",
			dpAny: "Alle",
			brand: "Marke",
			loading: "Lade Rezept",
			headerLabel: "Rezept-Titel",
			headerTextContent: "Rezept-Inhalt",
			headerCreatedAt: "Erstellungsdatum",
			headerChangedAt: "Änderungsdatum (last modified)",
			counter: "Zähler",
			dpEdit: "Bearbeiten",
			dpView: "Anzeigen",
			messageDeleted: "Rezept gelöscht",
			errorOnDeleting: "Fehler beim Löschen",
			createRecipe: "Rezept erstellen"
		},
		recipe: {
			recipeLabel: "Rezept",
			newRecipe: "Neues Rezept",
			messageDeleteRecipe: "Rezept löschen",
			messageDeleteRecipeTitle: "Bist du sicher, dass du dieses Rezept löschen möchtest? Es wird überall gelöscht, wo es derzeit verbaut ist.",
			deleteRecipe: "Löschen",
			placeholder: "Rezept auswählen",
			messageDeleted: "Rezept gelöscht",
			errorOnDeleting: "Fehler beim Löschen des Rezepts",
			errorFailedLoadedRecipeWithId: "Fehler beim Abrufen des Rezepts",
			handledInLegacySystem: "Dieses Rezept wird in {source} behandelt, Sie können es nicht auf Vibe bearbeiten"
		},
		recipeEdit: {
			label: "Titel des Rezepts",
			counter: "Zähler",
			editRecipe: "Rezept bearbeiten",
			messageSaved: "Rezept gespeichert",
			messageUpdated: "Änderungen gespeichert",
			season: "Jahreszeit",
			categories: "Kategorien",
			fitFactors: "Fit-Faktoren",
			difficulty: "Schwierigkeitsgrad",
			effort: "Aufwand",
			basics: "Basics",
			ingredients: "Zutaten",
			preparation: "Zubereitung",
			addIngredient: "Zutat hinzufügen",
			ingredientsName: "Name der Zutat",
			ingredientsAmount: "Menge",
			ingredientsUnit: "Einheit",
			addPreparationStep: "Zubereitungsschritt hinzufügen",
			preparationStepDescription: "Beschreibung",
			preparationStepIngredients: "Zutaten",
			cookingTime: "Kochzeit (Minuten)",
			totalTime: "Gesamtzeit (Minuten)",
			minutes: "Minuten",
			noTime: "Keine Zeitangabe",
			portions: "Portionen",
			portionUnit: "Portions-Einheit",
			closingText: "Abschlusstext",
			nutritionalValues: {
				title: "Nährwerte",
				calories: "Kalorien (kcal)",
				protein: "Eiweiß (g)",
				carbs: "Kohlenhydrate (g)",
				fat: "Fett (g)"
			}
		},
		season: {
			winter: "Winter",
			spring: "Frühling",
			easter: "Ostern",
			summer: "Sommer",
			fall: "Herbst",
			christmas: "Weihnachten"
		},
		difficulty: {
			easy: "Einfach",
			medium: "Mittel",
			hard: "Schwierig"
		},
		effort: {
			quick: "Schnell",
			medium: "Mittel",
			long: "Aufwendig"
		},
		category: {
			fruehstueck: "Frühstück/Snack",
			fleisch: "Fleisch",
			fisch: "Fisch",
			pasta: "Pasta",
			vegetarisch: "Vegetarisch",
			suppe: "Suppe",
			drink: "Drink",
			salat: "Salat",
			vorspeise: "Vorspeise",
			dessert: "Dessert",
			vegan: "Vegan",
			smoothie: "Smoothie",
			superfood: "Superfood",
			snack: "Snack",
			hauptgericht: "Hauptgericht",
			rohkost: "Rohkost",
			mealprep: "Mealprep",
			"schnelle-rezepte": "Schnelle Rezepte",
			kekse: "Kekse",
			brot: "Brot",
			kuchen: "Kuchen",
			gefluegel: "Geflügel",
			rindfleisch: "Rindfleisch",
			schweinefleisch: "Schweinefleisch",
			wild: "Wild",
			preiswert: "Preiswert",
			ofengerichte: "Ofengerichte",
			asiatisch: "Asiatisch",
			mediterran: "Mediterran",
			orientalisch: "Orientalisch",
			"dips-aufstriche": "Dips & Aufstriche"
		},
		fitFactor: {
			"low-fat": "Low Fat",
			"low-carb": "Low Carb",
			"weniger-als-300-kcal": "Weniger als 300 kcal",
			eiweissbetont: "Eiweißbetont",
			"gegen-heisshunger": "Gegen Heißhunger",
			muskelaufbau: "Muskelaufbau",
			regeneration: "Regeneration (Kohlenhydrate & Eiweiß)",
			paleo: "Paleo",
			glutenfrei: "Glutenfrei",
			laktosefrei: "Laktosefrei",
			zuckerfrei: "Zuckerfrei",
			vitaminreich: "Vitaminreich",
			ballaststoffreich: "Ballaststoffreich",
			basisch: "Basisch",
			"unter-500-kcal": "Unter 500 kcal",
			"clean-eating": "Clean Eating",
			detox: "Detox"
		},
		portionUnit: {
			person: "Person(en)",
			piece: "Stück"
		}
	}
}, r = [{
	path: "/recipe",
	children: [
		{
			path: "",
			name: "recipe_list",
			component: () => import("./recipe-list.view-BYHKTjcG.js").then((e) => e.n),
			meta: { requiredRight: "recipes:navigate" }
		},
		{
			path: "new",
			name: "recipe_new",
			component: () => import("./recipe-edit.view-D1wBDwae.js").then((e) => e.n),
			props: () => ({
				title: t().t("recipe.newRecipe"),
				backRoute: "/recipe"
			}),
			meta: { requiredRight: ["recipes:navigate"] }
		},
		{
			path: ":id",
			name: "recipe_detail",
			component: () => import("./recipe-edit.view-D1wBDwae.js").then((e) => e.n),
			props: (e) => ({
				title: t().t("recipeEdit.editRecipe"),
				id: e.params.id,
				backRoute: "/recipe"
			}),
			meta: { requiredRight: ["recipes:navigate"] }
		}
	]
}], i = e(() => import("./recipe-content-block-CO48EVmF.js")), a = {
	messages: n,
	routes: r,
	contentBlocks: [{
		type: "RECIPE",
		label: "recipe.recipeLabel",
		icon: "recipe",
		component: i,
		defaultValue: { type: "RECIPE" }
	}]
};
//#endregion
export { i as RecipeContentBlock, a as recipeModule };

//# sourceMappingURL=index.es.js.map